module.exports = function (bootstrap) {

    "use strict";

    bootstrap.directive('glossary', function(){
        return {
            replace: false,
            scope: false,
            template: require('articles/providers/glossary/glossary.html'),
            controller: ['$scope', '$location', '$state', '$anchorScroll', 'glossary', 'storage',
                function ($scope, $location, $state, $anchorScroll, glossary, storage) {

                var glossaryDetails = {},
                    transform = function (terms) {
                        if (terms) {
                            for (var i = 0; i < terms.length; i++) {
                                if (glossaryDetails.id) {
                                    for (var j = 0; j < terms[i].id.length; j++) {
                                        if (terms[i].id[j] === $scope.id) {
                                            terms[i].isOpen = true;
                                            break;
                                        } else {
                                            terms[i].isOpen = false;
                                        }
                                    }
                                } else if (glossaryDetails.title) {
                                    for (var k = 0; k < terms.length; k++) {
                                        if (terms[k].title === glossaryDetails.title) {
                                            terms[k].isOpen = true;
                                            break;
                                        } else {
                                            terms[k].isOpen = false;
                                        }
                                    }
                                }
                            }
                            return terms;
                        }
                    };

                if($state.params.details){
                    glossaryDetails = $state.params.details;
                    storage.set('hmProviderGlossaryDetails', JSON.stringify($state.params.details));
                }
                else if(storage.get('hmProviderDetails')) {
                    glossaryDetails = JSON.parse(storage.get('hmProviderGlossaryDetails'));
                }

                $scope.letters = [];

                for(var alpha = 0; alpha < 26; alpha++){
                    var newLetter = {
                        letter: String.fromCharCode(65 + alpha),
                        exists: false
                    };
                    $scope.letters.push(newLetter);
                }

                $scope.query = glossaryDetails.title;

                $scope.id = glossaryDetails.id;

                $scope.scrollTo = function (letter) {

                    //alphabetize terms
                    var terms = $scope.terms,
                        breakTerm = null,
                        compare = function (a, b) {
                            if (a.title < b.title) {
                                return -1;
                            }
                            if (a.title > b.title) {
                                return 1;
                            }
                            return 0;
                        };

                    terms.sort(compare);

                    for (var i=0; i<terms.length; i++) {
                        if (terms[i].title.substring(0,1) === letter) {
                            breakTerm = terms[i].title;
                            break;
                        }
                    }

                    if (breakTerm) {
                        $location.hash(breakTerm);
                        $anchorScroll();
                        document.getElementById(breakTerm).focus();
                    }
                };

                function initialize(){

                    glossary.fetch().then(function (res) {

                        $scope.terms = transform(res.data);

                        if ($scope.terms) {
                            if (!$scope.query) {
                                for (var i = 0; i < $scope.terms.length; i++) {
                                    for (var j = 0; j < $scope.terms[i].id.length; j++) {
                                        if ($scope.id === $scope.terms[i].id[j]) {
                                            $scope.query = $scope.terms[i].title;
                                        }
                                    }
                                }
                            }

                            var terms = $scope.terms;
                            for (var i = 0; i<terms.length; i++) {
                                if (terms[i].title === $scope.query||terms[i].title === $location.hash()) {
                                    terms[i].isOpen=true;
                                    break;
                                }
                            }
                            //pause so query is defined before scroll
                            setTimeout(function () {
                                $location.hash($scope.query);
                                $anchorScroll();
                            }, 50);

                            for (var i = 0; i < $scope.letters.length; i++) {
                                for (var j = 0; j < $scope.terms.length; j++) {
                                    if ($scope.letters[i].letter === $scope.terms[j].title.substring(0, 1)) {
                                        $scope.letters[i].exists = true;
                                    }
                                }
                            }
                        }

                    }, function (err) {
                        console.log('Terms not found.');
                    });
                }

                initialize();

            }]

        };
    });
};